import React, { useReducer } from 'react';
import axios from 'axios';
import AuthContext from './AuthContext';
import authReducer from './authReducer';
import {
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    USER_LOADED,
    AUTH_ERROR,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    CLEAR_ERRORS
} from '../types';
import { use } from 'react';

const AuthState = (props) => {
  const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: null,
    loading: true,
    error: null,
  };

  const [state, dispatch] = useReducer(authReducer, initialState);

  // Placeholder for the actual implementation of methods
  // Load User
  const loadUser = () => {
    // Implementation for loading a user goes here
  };

  // Register User
  const registerUser = () => {
    // Implementation for registering a user goes here
  };

  // Login User
  const loginUser = () => {
    // Implementation for logging in a user goes here
  };

  // Logout
  const logoutUser = () => {
    // Implementation for logging out a user goes here
  };

  // Clear Errors
  const clearErrors = () => {
    // Implementation for clearing errors goes here
  };

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        loading: state.loading,
        user: state.user,
        userType:state.userType,
        error: state.error,
        loadUser,
        registerUser,
        loginUser,
        logoutUser,
        clearErrors,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
